import { Component, Input } from "@angular/core"
import { ModalRef } from "../../modal/modal-ref"

@Component({
    selector: "app-information-modal",
    templateUrl: "./information-modal.component.html",
    styleUrls: ["./information-modal.component.less"],
})
export class InformationModalComponent {
    @Input() message: string

    constructor(public activeModal: ModalRef) {}
}
